import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const width = '130px';

const Avatar = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${width};
  height: ${width};
  margin-right: 35px;
  border-radius: 50%;
  background-color: ${colors['pale-grey']};

  ${({ src }) => src && `
    background-image: url(${src});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  `}

  & > div {
    width: ${width};
    height: 100%;
  }

  .avatarImageDropZone {
    width: ${width};
    height: 100%;
    margin: 0;
    border-radius: 50%;
    cursor: pointer;
    background-color: ${props => (props.colorScheme === 'grey' ? colors['light-grey'] : 'initial')};

    &:hover > svg > path {
      fill: ${colors['warm-grey-two']};
      transition: fill 0.25s ease-in-out;
    }
  }
`;

export default Avatar;
